import { render } from "./LeagueInfo.vue?vue&type=template&id=d0810c28"
import script from "./LeagueInfo.vue?vue&type=script&lang=js"
export * from "./LeagueInfo.vue?vue&type=script&lang=js"

import "./LeagueInfo.vue?vue&type=style&index=0&id=d0810c28&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__